import React from "react";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="content">
                Made with <span className="nes-icon is-small heart"></span> by <a href="https://twitter.com/keosariel" target="_blank">Keosariel</a>
            </div>
        </footer>
    );
};

export default Footer;